// extracted by mini-css-extract-plugin
module.exports = {"ColoredBoxes":"style_ColoredBoxes__1wIwP"};